// extracted by mini-css-extract-plugin
export default {"separator":"COMComponent_separator__Dpkhr","title":"COMComponent_title__hixbt","comment":"COMComponent_comment__B-Y+u"};